import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function initImageParallax() {
    gsap.utils.toArray(".image-parallax").forEach(parallaxContainer => {
        const parallaxImage = parallaxContainer.querySelector("img");
        const parallaxTl = gsap.timeline({
            scrollTrigger: {
                trigger: parallaxContainer,
                scrub: true,
                pin: false,
            },
        });
        parallaxTl.fromTo(
            parallaxImage,
            { yPercent: -50, ease: "none" },
            { yPercent: 50, ease: "none" }
        );
    });
}

